import { useMutation } from 'react-query';
import { Http } from '../../services/Http';
import { MUTATION_KEYS } from '../constants';
import { useInvalidateApprovalDelegates } from './useApprovalDelegates';

/** Remove one or many delegations. A single id uses DELETE /:id; multiple use DELETE with a body. */
async function removeApprovalDelegates(ids: number[]): Promise<{ removed: number }> {
  if (ids.length === 1) {
    const { data } = await Http.axios.delete<{ removed: number }>(`/approval-delegate/${ids[0]}`);
    return data;
  }
  const { data } = await Http.axios.delete<{ removed: number }>('/approval-delegate', {
    data: { ids },
  });
  return data;
}

export const useRemoveApprovalDelegates = () => {
  const invalidate = useInvalidateApprovalDelegates();
  return useMutation(removeApprovalDelegates, {
    mutationKey: MUTATION_KEYS.REMOVE_APPROVAL_DELEGATES,
    onSuccess: invalidate,
  });
};
